import { err, ok, Result } from "neverthrow";
import { buildConflictError, buildNotFoundError } from "./error.js";
/**
 * Transforms a value that may be undefined into a Result.
 * @param value
 * @returns
 */
export const defined = (value, error = "Value is undefined or null") => (value ?? undefined) === undefined
    ? err(error)
    : ok(value);
export function mustBeDefined(message) {
    return (value) => (value ?? undefined) === undefined
        ? err(buildNotFoundError({ message }))
        : ok(value);
}
export function mustBeNullish(message) {
    return (value) => value === undefined
        ? ok(undefined)
        : value === null
            ? ok(null)
            : err(buildConflictError({ message }));
}
//# sourceMappingURL=defined.js.map